import React, { useState, useEffect, useRef } from "react";
import { createAppointmentPublic, sendAppointmentConfirmationEmail } from "../../api";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Modal from "react-bootstrap/Modal";
import Alert from "react-bootstrap/Alert";
import { FaCheck, FaTimes } from "react-icons/fa";
import { generateOzowLink, createPaymentLink } from "../../afinanceapi"; // Adjust the import path as necessary
import { executeRecaptcha } from "./recaptchaHelpers";


import "./FullCalendar.css";

export function AddAppointmentModal({
  show,
  onHide,
  selectedDate,
  selectedTime,
  selectedResource,
  selectedPractice,
  selectedService,
  transactionRef,
  amount,
  isUpfrontPayable,
  isOnlinePaymentEnabled,
  times,
  onSave,
  events,
}) {
  const [closeAlert, setCloseAlert] = useState(false);
  const [showPayment, setShowPayment] = useState(false);
  const [paymentUrl, setPaymentUrl] = useState("");
  const [saveAlert, setSaveAlert] = useState(false);
  const modalBodyRef = useRef(null);
  const [errors, setErrors] = useState({});
  const [appointmentComments, setAppointmentComments] = useState("");
  const [payload, setPayload] = useState();

  const [appointment, setAppointment] = useState({
    title: "", // Default to patient name
    patientFirstName: "",
    patientLastName: "",
    patientDOB: "",
    start: times?.start || "", // Default to selected date
    end: times?.end,
    patientId: "",
    serviceId: selectedService?._id || "",
    reminderInterval: [],
    reminderType: [],
    notes: "",
    resourceName: selectedResource
      ? `${selectedResource.firstName || ""}  ${
          selectedResource.lastName || ""
        }`
      : "",
    resourceId: selectedResource?.resourcesId || "",
    practiceId: selectedPractice?.practiceNumber || "",
    status: "Pending",
    eventColor: "",
    patientEmail: "",
    borderColor: "#0F3490",
    backgroundColor: "#0F3490",
    appointmentCreatedBy: "",
    appointmentCreatedDate: "",
    onlineTransactionRef: transactionRef || "",
  });
  console.log("Selected Date:", selectedDate);

  useEffect(() => {
    if (
      selectedPractice &&
      selectedResource &&
      selectedService &&
      selectedTime &&
      selectedDate
    ) {
      setAppointment((prevState) => ({
        ...prevState,
        practiceId: selectedPractice?.practiceNumber || "",
        practiceName: selectedPractice?.practiceName || "",
        resourceId: selectedResource?.id || "",
        resourceName: selectedResource
          ? `${selectedResource.firstName || ""}  ${
              selectedResource.lastName || ""
            }`
          : "",
        serviceId: selectedService?._id || "",
        notes: selectedService?.servicesDescription || "",
        start: times?.start || "",
        end: times?.end || "",
      }));
    }
  }, [
    selectedDate,
    selectedPractice,
    selectedResource,
    selectedService,
    selectedTime,
    times,
  ]);

  useEffect(() => {
    if (saveAlert) {
      // Scroll the page and modal to the top
      window.scrollTo({ top: 0, behavior: "smooth" });
      if (modalBodyRef.current) {
        modalBodyRef.current.scrollTop = 0;
      }
    }
  }, [saveAlert]);

  const handleChangeAppointment = async (e) => {
    const { name, value } = e.target;

    if (name === "notes" || name === "appointmentComments") {
      // Append appointmentComments to the original serviceDescription
      setAppointment((prevState) => ({
        ...prevState,
        notes: `${selectedService?.servicesDescription || ""}\n${value}`,
      }));
    } else {
      // Normal field update
      setAppointment((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  function validateForm() {
    let newErrors = {};
    if (
      !appointment.patientEmail ||
      !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(appointment.patientEmail)
    ) {
      newErrors.patientEmail = "Enter a valid email address.";
    }
    if (!appointment.patientFirstName)
      newErrors.patientFirstName = "First name is required.";
    if (!appointment.patientLastName)
      newErrors.patientLastName = "Last name is required.";
    if (!appointment.patientDOB)
      newErrors.patientDOB = "Date of birth is required.";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return false if errors exist
  }

function submitOzowPaymentForm(formData, actionUrl) {
  // Create a form element
  const form = document.createElement('form');
  form.method = 'POST';
  form.action = actionUrl;
  form.style.display = 'none';

  // Add all form fields
  Object.keys(formData).forEach(key => {
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = key;
    input.value = formData[key];
    form.appendChild(input);
  });

  // Add form to document, submit it, then remove it
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
}

// Updated handleSaveAppointment function
async function handleSaveAppointment() {
  if (!validateForm()) {
    console.error("Validation failed!");
    return;
  }

  try {
    // Attempt to get reCAPTCHA token
    let recaptchaToken;
    try {
      recaptchaToken = await executeRecaptcha('book_appointment');
    } catch (e) {
      console.error('reCAPTCHA not yet available or failed:', e.message);
      alert('Security verification is loading. Please try again in a moment.');
      return;
    }

    if (!recaptchaToken) {
      console.error('No reCAPTCHA token returned');
      alert('Security verification failed. Please refresh and try again.');
      return;
    }

    // Prepare appointment with token
    const appointmentWithCaptcha = {
      ...appointment,
      recaptchaToken,
      userAgent: navigator.userAgent,
      timestamp: Date.now()
    };

    console.log("Saving appointment:", appointmentWithCaptcha);
    const response = await createAppointmentPublic(appointmentWithCaptcha);
    console.log("Appointment saved successfully:", response);
    onSave(response);
    console.log("Appointment data:", appointment);


      
      console.log("Response from createAppointmentPublic:", response);
      const paymentPayload = {
        paymentRequestId: "OnlinePayment",
        selectedDate,
        selectedTime,
        selectedResource,
        selectedPractice,
        practiceNumber: selectedPractice?.practiceNumber,
        selectedService,
        transactionReference: transactionRef,
        amount,
        appointmentId: response.appointment._id,
        patientId: response.appointment.patientId,
      };
      
      setPayload(paymentPayload); // For state management

      const paymentResponse = await createPaymentLink(paymentPayload);

      if (isOnlinePaymentEnabled && isUpfrontPayable) {
        const priceStr = selectedService.settings?.websitePrice || "0";
        const totalSelectedAmount = parseFloat(priceStr.replace(/[^\d.-]/g, ""));

        const ozowRes = await generateOzowLink({
          practiceNumber: selectedPractice.practiceNumber,
          totalSelectedAmount,
          accountLastName: `${appointment.patientLastName} ${appointment.patientFirstName}`,
          transactionRef,
        });
        
        console.log("Ozow response:", ozowRes);
        
        // Submit the form to redirect to Ozow payment page
        if (ozowRes && ozowRes.formData && ozowRes.actionUrl) {

          console.log("Submitting Ozow payment form...");
          submitOzowPaymentForm(ozowRes.formData, ozowRes.actionUrl);
        } else {
          console.error("No valid form data received from Ozow");
          setSaveAlert(true);
          setTimeout(() => {
            setSaveAlert(false);
            onHide();
          }, 2000);
        }
      } else {
        setSaveAlert(true);
        setTimeout(() => {
          setSaveAlert(false);
          onHide();
        }, 2000);
      }
      
    } catch (error) {
    console.error("Error saving appointment:", error);
    if (error.message.includes('reCAPTCHA') || error.response?.data?.error?.includes('reCAPTCHA')) {
      alert('Security verification failed. Please try again.');
    } else {
      alert('Failed to save appointment. Please try again.');
    }
    setSaveAlert(false);
  }
}




  const handleCancelNo = () => {
    setCloseAlert(false); // Hide alert and keep modal open
  };

  const handleCancelYes = () => {
    setCloseAlert(false); // Hide alert first
    setAppointment({});
    onHide();
  };

  return (
  <Modal
    show={show}
    onHide={onHide}
    size="lg"
    centered
    dialogClassName="responsive-modal"
  >
    <Modal.Header closeButton={!closeAlert}>
  <div className="w-100">
    <Modal.Title className="mb-1 text-primary fw-normal">
      {showPayment ? "Complete Payment" : "Your Appointment"}
    </Modal.Title>
  </div>
</Modal.Header>

    {closeAlert && (
      <Alert
        variant="info"
        className="w-100 d-flex align-items-center justify-content-between"
      >
        <span>
          Are you sure you want to close? The entered data will be removed.
        </span>
        <div className="d-flex">
          <Button
            variant="outline-primary"
            className="btn btn-outline-primary me-2"
            onClick={handleCancelYes}
          >
            <FaCheck />
          </Button>
          <Button
            variant="outline-secondary"
            className="btn btn-outline-secondary"
            onClick={handleCancelNo}
          >
            <FaTimes />
          </Button>
        </div>
      </Alert>
    )}

    {saveAlert && (
      <Alert
        variant="success"
        className="w-100 d-flex align-items-center justify-content-between"
        onClose={() => setSaveAlert(false)}
      >
        The appointment was successfully added!
      </Alert>
    )}

   <Modal.Body ref={modalBodyRef} style={{ overflowY: "auto", maxHeight: "600px" }}>
  {showPayment && paymentUrl ? (
    <div>
      <div className="alert alert-info mb-3">
        <strong>Payment Required</strong><br/>
        Please complete your payment to confirm your appointment.
      </div>
      <div style={{ height: "600px", border: "1px solid #dee2e6", borderRadius: "0.375rem" }}>
        <iframe
          src={paymentUrl}
          title="Ozow Payment"
          style={{ width: "100%", height: "100%", border: "none", borderRadius: "0.375rem" }}
        />
      </div>
      <div className="mt-3 text-center">
        <Button 
          variant="outline-secondary" 
          onClick={() => {
            setShowPayment(false);
            setPaymentUrl("");
          }}
        >
          ← Back to Appointment Details
        </Button>
      </div>
    </div>
  ) : (
    <Form>
          <Row className="mb-2">
            <Col>
              <p className="fw-bold mb-1">{appointment?.resourceName}</p>
              <p className="mb-0 ms-2">{selectedService?.servicesName}</p>
              <p className="mb-0 ms-2">
                {selectedService?.servicesDescription}
              </p>
              <p className="mb-0 ms-2">{appointment?.start}</p>
            </Col>
            <Col>
              <p className="fw-bold mb-1">{selectedPractice?.practiceName}</p>
              <p className="mb-0 ms-2">
                {selectedPractice?.practiceAddress},{" "}
                {selectedPractice?.practiceAddress2}
              </p>
              <p className="mb-0 ms-2">
                {selectedPractice?.practiceCity},{" "}
                {selectedPractice?.practicePostalCode}
              </p>
            </Col>
          </Row>
          <hr />
          <p className="mb-2">
            Please complete the detail below, if you are on medical aid just
            add the number and the dependant code if you are not on medical
            aid leave the fields blank. Once completed press submit to
            schedule your appointment.
          </p>

          <Row className="mb-3">
            <Col>
              <Form.Group controlId="patientFirstName">
                <Form.Label className="fw-semibold">
                  Patient First Name
                </Form.Label>
                <Form.Control
                  type="text"
                  name="patientFirstName"
                  value={appointment.patientFirstName}
                  onChange={handleChangeAppointment}
                  isInvalid={!!errors.patientFirstName}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.patientFirstName}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col>
              <Form.Group controlId="patientLastName">
                <Form.Label className="fw-semibold">
                  Patient Last Name
                </Form.Label>
                <Form.Control
                  type="text"
                  name="patientLastName"
                  value={appointment.patientLastName}
                  onChange={handleChangeAppointment}
                  isInvalid={!!errors.patientLastName}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.patientLastName}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={4}>
              <Form.Group controlId="patientDOB">
                <Form.Label className="fw-semibold">Date of Birth</Form.Label>
                <Form.Control
                  type="date"
                  name="patientDOB"
                  value={appointment.patientDOB || ""}
                  onChange={handleChangeAppointment}
                  isInvalid={!!errors.patientDOB}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.patientDOB}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col md={8}>
              <Form.Group controlId="patientEmail">
                <Form.Label className="fw-semibold">Patient Email</Form.Label>
                <Form.Control
                  type="text"
                  name="patientEmail"
                  value={appointment.patientEmail}
                  onChange={handleChangeAppointment}
                  isInvalid={!!errors.patientEmail}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.patientEmail}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col md={4}>
              <Form.Group controlId="medicalAidNumber">
                <Form.Label className="fw-semibold">
                  Medical Aid Number
                </Form.Label>
                <Form.Control
                  type="text"
                  name="medicalAidNumber"
                  value={appointment.medicalAidNumber || ""}
                  onChange={handleChangeAppointment}
                />
              </Form.Group>
            </Col>
            <Col md={2}>
              <Form.Group controlId="dependantCode">
                <Form.Label className="fw-semibold">
                  Dependant Code
                </Form.Label>
                <Form.Control
                  type="text"
                  name="dependantCode"
                  value={appointment.dependantCode || ""}
                  onChange={handleChangeAppointment}
                />
              </Form.Group>
            </Col>
          </Row>

          <Row className="mb-3">
            <Form.Group controlId="appointmentNotes">
              <Form.Label className="fw-semibold">
                Any Additional Comments
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="notes"
                value={appointmentComments}
                onChange={(e) => {
                  setAppointmentComments(e.target.value);
                  handleChangeAppointment(e);
                }}
              />
            </Form.Group>
          </Row>

          <Button variant="primary w-25" onClick={handleSaveAppointment}>
            Submit
          </Button>
        </Form>
      )}
    </Modal.Body>
  </Modal>
);
}
